import thirdPillarReducer from './reducer';
import * as actionsModule from './actions';

export const reducer = thirdPillarReducer;
export const actions = actionsModule;
